<template>
    <div>
        <vue-perfect-scrollbar style="height: 408px" :settings="settings">
            <v-list class="card-list">
                <v-list-tile ripple v-for="(sale, index) in subscriptions" :key="index">
                    <v-list-tile-content>
                        <v-list-tile-sub-title>
                            <h5 class="mb-0">{{ sale.company }}</h5>
                            <v-list-tile-action-text class="fw-light" @click.stop="$copyToClipboard(sale.stripe_subscription_id)">
                                <span
                                    v-if="
                                        doesNotHaveLoginType([
                                            'csr',
                                            'producer',
                                            'dispatcher',
                                            'technician',
                                            'driver',
                                            'dispenser_mgr',
                                            'customer',
                                            'customer_readonly',
                                        ])
                                    "
                                    >{{ "$" + sale.amount }}</span
                                >
                            </v-list-tile-action-text>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action style="align-items: center">
                        <small class="fw-light" style="text-align: center; font-size: 10px">Expires On:</small>
                        <span v-if="sale.status == 'active'" class="color-success" style="cursor: default"
                            ><strong>{{ sale.period_end }}</strong></span
                        >
                        <span v-else-if="sale.status == 'expiring_soon'" class="color-warning" style="cursor: default"
                            ><strong>{{ sale.period_end }}</strong></span
                        >
                        <span v-else-if="sale.status == 'inactive'" class="color-danger" style="cursor: default"
                            ><strong>{{ sale.period_end }}</strong></span
                        >
                        <span v-else-if="sale.status == 'expired'" class="color-error" style="cursor: default"
                            ><strong>{{ sale.period_end }}</strong></span
                        >
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </vue-perfect-scrollbar>
        <app-section-loader :status="loader"></app-section-loader>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Clipboard from "clipboard";
import api from "Api";
import AppSectionLoader from "Components/AppSectionLoader/AppSectionLoader";

export default {
    data() {
        return {
            loader: true,
            recentSales: [],
            settings: {
                maxScrollbarLength: 160,
            },
        };
    },

    computed: {
        ...mapState({
            subscriptions: (state) => state.subscriptions.subscription_options,
            company_options: (state) => state.companies.company_options,
        }),
    },
    methods: {
        ...mapActions(["fetchCompanies", "fetchSubscriptions"]),
        getSubscriptions(refresh = false) {
            this.loader = true;
            this.$store.commit("mutate", {
                property: "subscription_options",
                with: [],
            });
            this.fetchSubscriptions({ body: { billable: "1", options: "1" } }).then((data) => {
                this.loader = false;
            });
        },
        refresh() {
            // if (this.company_options.length == 0) await this.fetchCompanies({ body: { options: 1 } });
            this.getSubscriptions();
        },
    },
    mounted() {
        this.refresh();
    },
    components: {
        AppSectionLoader,
    },
};
</script>
<style lang="css">
.icon-label {
    display: flex;
    align-items: center;
}

.label {
    margin-left: 10px; /* Adjust the margin as needed to control the space between the icon and the label */
}
</style>
